// extracted by mini-css-extract-plugin
export default {"insight":"InsightSupplement__insight__VG_6R"};
    if(module.hot) {
      // 1763020727008
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  